import React from "react";
import Day from "./Day";
import dayjs from "dayjs";
import "dayjs/locale/nl";

export default function Month({ month }) {
  dayjs.locale("nl");
  
  // Get day names from the first row
  const dayNames = month[0].map(day => day.format("ddd").toUpperCase());
  
  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden">
      {/* Day of week header */}
      <div className="grid grid-cols-7 border-b border-gray-100 dark:border-gray-800 flex-shrink-0">
        {dayNames.map((name, idx) => (
          <div key={idx} className={`text-[11px] md:text-xs text-center py-2 uppercase tracking-wide text-gray-400 font-medium ${idx >= 5 ? "bg-gray-50 dark:bg-gray-900" : ""}`}>
            {name}
          </div>
        ))}
      </div>
      
      {/* Calendar grid */}
      <div className="flex-1 grid grid-cols-7 grid-rows-6 overflow-hidden">
        {month.map((row, i) => (
          <React.Fragment key={i}>
            {row.map((day, idx) => (
              <Day day={day} key={idx} rowIdx={i} />
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
